import { LOCALE } from "../../../properties/Locale";
import * as yup from "yup";

export const authorshipValidator = yup.object().shape({
  laborName: yup.string().required(LOCALE.laborName + LOCALE.required_field),
  type: yup.object().shape({
    id: yup.string().required(LOCALE.type + LOCALE.required_field),
  }),
  role: yup.object().shape({
    id: yup.string().required(LOCALE.role + LOCALE.required_field),
  }),
  publicationName: yup
    .string()
    .required(LOCALE.publicationName + LOCALE.required_field),
  year: yup.string().required(LOCALE.year + LOCALE.required_field),
  proofs: yup.array().required(LOCALE.proof + LOCALE.required_field),
});

export const authorshipPointsValidator = yup.object().shape({
  points: yup.string().required(LOCALE.name + LOCALE.points),
  pointsChecked: yup.boolean().oneOf([true], "Must Approve Points"),
});
